import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const Row = ({ sid, r, onSaved }) => {
  const [note, setNote] = useState(r.note);
  const save = async (attendance) => {
    try { await api.post(`/club/sessions/${sid}/attendance`, { user_id: r.user_id, attendance, note }); toast.success("Guardado"); onSaved(); } catch (e) { toast.error(errMsg(e)); }
  };
  const pill = (v, label) => (
    <button onClick={() => save(v)} className={`px-3 py-1 rounded-full text-sm font-bold border-2 transition-colors ${r.attendance === v ? "bg-[#0B1D3A] text-white border-[#0B1D3A]" : "border-slate-300"}`} data-testid={`att-${v}-${r.user_id}`}>{label}</button>
  );
  return (
    <li className="py-3 pr-1 border-b border-slate-100">
      <div className="flex items-center gap-2"><p className="flex-1 font-bold" translate="no">{r.name}</p>{r.pay && <span className={`text-xs font-bold uppercase px-2 py-0.5 rounded ${r.pay === "pass" ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`} data-testid={`pay-${r.user_id}`}>{r.pay === "pass" ? "Bono" : "Suelta"}</span>}{pill("present", "Asiste")}{pill("absent", "Falta")}</div>
      <div className="flex gap-2 mt-2">
        <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Nota del instructor" className="flex-1 rounded-lg px-3 text-sm" data-testid={`note-${r.user_id}`} />
        <button onClick={() => save(r.attendance)} className="text-sm font-bold text-[#3D88B8] px-2" data-testid={`note-save-${r.user_id}`}>Guardar</button>
      </div>
    </li>
  );
};

export const Roster = ({ session, onClose }) => {
  const [data, setData] = useState(null);
  const load = () => api.get(`/club/sessions/${session.id}/roster`).then((r) => setData(r.data)).catch(() => setData({ booked: [], waitlist: [] }));
  useEffect(() => { load(); }, [session.id]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="fixed inset-0 z-[60] bg-[#0B1D3A]/60 flex justify-end" onClick={onClose} data-testid="roster-panel">
      <div className="bg-white w-full max-w-md h-full overflow-y-auto p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between"><div><h3 className="font-display font-black text-2xl">{session.title}</h3><p className="text-slate-500">{session.date} · {session.time}</p></div>
          <button onClick={onClose} aria-label="Cerrar" data-testid="roster-close"><X /></button></div>
        {!data ? <p className="mt-6">Cargando…</p> : (
          <>
            <h4 className="mt-6 font-bold text-[#3D88B8] uppercase text-sm">Apuntados ({data.booked.length})</h4>
            <ul>{data.booked.map((r) => <Row key={r.user_id} sid={session.id} r={r} onSaved={load} />)}</ul>
            {!!data.waitlist.length && <><h4 className="mt-6 font-bold text-slate-500 uppercase text-sm">Lista de espera</h4><ul className="text-slate-600">{data.waitlist.map((r, i) => <li key={r.user_id} className="py-1">{i + 1}. {r.name}</li>)}</ul></>}
          </>
        )}
      </div>
    </div>
  );
};
